module.exports = __webpack_public_path__ + "120cebeb0a73022dea40ad48d438fda8.png";